/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const layout_card = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#layout_card_svg__a)"
      clipRule="evenodd"
    >
      <path d="M1 2.448C1 1.648 1.648 1 2.448 1h11.104c.8 0 1.448.648 1.448 1.448v2.704c0 .8-.648 1.448-1.448 1.448H2.448C1.648 6.6 1 5.952 1 5.152V2.448Zm0 8.4c0-.8.648-1.448 1.448-1.448h11.104c.8 0 1.448.649 1.448 1.448v2.704c0 .8-.648 1.448-1.448 1.448H2.448C1.648 15 1 14.352 1 13.552v-2.704Z" />
    </g>
    <defs>
      <clipPath id="layout_card_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default layout_card
